import { UserTheme } from "../users";
import { z } from "zod";
export const PortalSettingsTheme = UserTheme;
export const PortalSettingsSidebarLink = z.object({
    name: z.string(),
    url: z.string(),
    emoji: z.string(),
});
export const PortalSettingsSidebarSection = z.object({
    sectionName: z.string(),
    links: z.array(PortalSettingsSidebarLink),
});
export const PortalSettingsSidebar = z.array(PortalSettingsSidebarSection);
export const PortalSettings = z.object({
    id: z.string(),
    workspaceId: z.string(),
    enabledDesignSystemIds: z.array(z.string()),
    enabledBrandPersistentIds: z.array(z.string()),
    theme: PortalSettingsTheme.nullish(),
    sidebar: PortalSettingsSidebar.nullish(),
    isMigrated: z.boolean(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
